function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M8.858 13.869C3.649 19.078.574 26.6 1.889 30.914c1.295 4.247 21.015 72.154 43.822 150.904 22.807 78.75 47.201 162.965 54.208 187.144 20.387 70.346 29.414 72.78 72.836 19.64l27.885-34.125 38.631 45.489c48.409 57.002 46.658 56.898 105.815 6.28 56.211-48.097 56.065-46.104 7.61-103.973l-38.061-45.455 37.905-21.824c69.234-39.863 70.713-38.404-145.165-143.242C10.739-3.742 22.037.691 8.858 13.869M274.75 174.255l49.75 24.309-32.705 19.1c-44.189 25.808-43.89 30.171 6.088 88.982 45.029 52.989 43.199 46.206 17.833 66.081-26.628 20.865-24.48 21.083-44.696-4.526-63.258-80.132-71.247-83.481-103.919-43.563-13.138 16.051-24.269 28.8-24.738 28.332-.926-.927-83.272-280.446-83.272-282.663 0-1.207 33.677 15.026 215.659 103.948",
  fill: "#5B576A",
  fillRule: "evenodd"
});

function SvgCursor(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    viewBox: "0 0 400 445.455"
  }, props), _ref);
}

export default SvgCursor;